import { ManageRepayments } from "./manageRepayments";

export default ManageRepayments;